<md-button layout="row" layout-align="center center" md-colors="{background: 'accent'}" ng-click="vm.exportToCsv()">
  {{'CSV' | translate}} <i class="material-icons">file_download</i></md-button>
